import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '50vh',
    minHeight: 450,
    '& h1': {
      margin: '0.5em',
    },
    '& h2': {
      margin: '0.5em',
    },
    '& p': {
      margin: '0.5em',
    },
  },
}));

function P404() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <h1>Błąd 404</h1>
      <h2>Strona nie została odnaleziona</h2>
    </div>
  );

}

export default P404;